import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Card, Alert, ProgressBar } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Header from '~/Components/Header/Header';
import FiltrosCobranca from './components/FiltrosCobranca';
import FiltrosJuridico from './components/FiltrosJuridico';
import GridResultado from './components/GridResultado';
import BarraAcoes from './components/BarraAcoes';
import ModalConfirmacaoEnvio from './components/ModalConfirmacaoEnvio';
import ModalResultadoEnvio from './components/ModalResultadoEnvio';
import ModalGerenciarMensagens from './components/ModalGerenciarMensagens';
import {
  pesquisar,
  enviar,
  listarCobradores,
  listarGesUsuario,
  listarClientes,
} from './services/cobrancaSmsService';

const CobrancaSms = ({ modo = 'C' }) => {
  const [registros, setRegistros] = useState([]);
  const [selecionados, setSelecionados] = useState([]);
  const [ultimosFiltros, setUltimosFiltros] = useState(null);
  const [tipoDisparo, setTipoDisparo] = useState('CPF');

  const [carregando, setCarregando] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const [totalSms, setTotalSms] = useState(0);
  const [totalSemMensagem, setTotalSemMensagem] = useState(0);

  const empreendimentos = useSelector((state) => state.empreendimentos.list);
  const [cobradores, setCobradores] = useState([]);
  const [ges, setGes] = useState([]);
  const [clientes, setClientes] = useState([]);

  const [showConfirmacao, setShowConfirmacao] = useState(false);
  const [showResultado, setShowResultado] = useState(false);
  const [resultadoEnvio, setResultadoEnvio] = useState(null);
  const [showGerenciarMensagens, setShowGerenciarMensagens] = useState(false);

  const handleGeChange = (codigoGrupoEmpresa) => {
    setClientes([]);
    if (!codigoGrupoEmpresa) return;
    listarClientes(codigoGrupoEmpresa)
      .then((data) => setClientes(Array.isArray(data) ? data : []))
      .catch((err) => toast.error(err.message || 'Erro ao carregar clientes'));
  };

  const handlePesquisar = async (filtros) => {
    setCarregando(true);
    setRegistros([]);
    setSelecionados([]);
    setUltimosFiltros(filtros);
    setTipoDisparo(filtros.tipo_disparo || 'CPF');
    try {
      const data = await pesquisar(filtros);
      const lista = data.registros || data || [];
      setRegistros(lista);
      setTotalSms(data.total_sms || lista.filter((r) => r.mensagem).length);
      setTotalSemMensagem(data.total_sem_mensagem || lista.filter((r) => !r.mensagem).length);

      const idsSelecionados = lista
        .filter((r) => r.mensagem && r.sel !== false)
        .map((r) => (filtros.tipo_disparo === 'CONTRATO' ? r.codigo_titulo : r.cpf));
      setSelecionados(idsSelecionados);
    } catch (err) {
      toast.error(err.message || 'Erro ao pesquisar');
    } finally {
      setCarregando(false);
    }
  };

  const handleLimpar = () => {
    setRegistros([]);
    setSelecionados([]);
    setUltimosFiltros(null);
    setTotalSms(0);
    setTotalSemMensagem(0);
  };

  const handleToggle = (id) => {
    setSelecionados((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const handleToggleAll = (ids, todosSelec) => {
    setSelecionados(todosSelec ? [] : ids);
  };

  const handleExcluirSelecionados = () => {
    const idsSelecionados = new Set(selecionados);
    const campo = tipoDisparo === 'CONTRATO' ? 'codigo_titulo' : 'cpf';
    const novosRegistros = registros.filter((r) => !idsSelecionados.has(r[campo]));
    setRegistros(novosRegistros);
    setSelecionados([]);
    setTotalSms(novosRegistros.filter((r) => r.mensagem).length);
    setTotalSemMensagem(novosRegistros.filter((r) => !r.mensagem).length);
  };

  const getRegistrosSelecionados = () => {
    const campo = tipoDisparo === 'CONTRATO' ? 'codigo_titulo' : 'cpf';
    return registros.filter((r) => selecionados.includes(r[campo]));
  };

  const handleAbrirEnvio = () => {
    const regs = getRegistrosSelecionados();
    if (regs.length === 0) {
      toast.error('Nenhum registro selecionado');
      return;
    }
    const semMensagem = regs.filter((r) => !r.mensagem);
    if (semMensagem.length > 0) {
      toast.error('Há registros sem mensagem. Exclua-os ou ajuste as faixas.');
      return;
    }
    setShowConfirmacao(true);
  };

  const handleConfirmarEnvio = async () => {
    setShowConfirmacao(false);
    setEnviando(true);
    const regs = getRegistrosSelecionados();
    try {
      const payload = {
        modo: ultimosFiltros ? ultimosFiltros.modo : modo,
        tipo: ultimosFiltros ? ultimosFiltros.tipo : (modo === 'J' ? 'J' : 'F'),
        tipo_disparo: tipoDisparo,
        registros: regs,
      };
      const resultado = await enviar(payload);
      setResultadoEnvio(resultado);
      setShowResultado(true);
    } catch (err) {
      toast.error(err.message || 'Erro ao enviar SMS');
    } finally {
      setEnviando(false);
    }
  };

  const handleFecharResultado = () => {
    setShowResultado(false);
    setResultadoEnvio(null);
    if (ultimosFiltros) {
      handlePesquisar(ultimosFiltros);
    }
  };

  return (
    <div className="container-fluid px-3 py-3">
      <Header title='Cobrança SMS' />

      <Card className="shadow-sm mb-3">
        <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }}>
          <strong>Filtros</strong>
        </Card.Header>
        <Card.Body className="py-2">
          <FiltrosCobranca
            empreendimentos={empreendimentos}
            onPesquisar={handlePesquisar}
            onLimpar={handleLimpar}
            onConfigurarMensagens={() => setShowGerenciarMensagens(true)}
            loading={carregando}
          />
        </Card.Body>
      </Card>

      {enviando && (
        <ProgressBar animated now={100} label="Enviando SMS..." className="mb-3" />
      )}

      {registros.length > 0 && (
        <Card className="shadow-sm mb-3">
          <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }}>
            <strong>Resultados</strong>
            {' — '}
            <span>{totalSms} SMS</span>
            {totalSemMensagem > 0 && (
              <span className="ml-2 text-warning">/ {totalSemMensagem} sem mensagem</span>
            )}
          </Card.Header>
          <Card.Body className="p-0">
            {registros.length >= 1000 && (
              <Alert variant="warning" className="m-2">
                Resultados limitados a 1000. Refine os filtros para ver mais.
              </Alert>
            )}
            <GridResultado
              registros={registros}
              tipoDisparo={tipoDisparo}
              selecionados={selecionados}
              onToggle={handleToggle}
              onToggleAll={handleToggleAll}
            />
          </Card.Body>
        </Card>
      )}

      {registros.length > 0 && (
        <BarraAcoes
          selecionados={selecionados}
          onEnviar={handleAbrirEnvio}
          onExcluir={handleExcluirSelecionados}
          onGerenciarMensagens={() => setShowGerenciarMensagens(true)}
          enviando={enviando}
        />
      )}

      <ModalConfirmacaoEnvio
        show={showConfirmacao}
        registros={getRegistrosSelecionados()}
        onConfirmar={handleConfirmarEnvio}
        onCancelar={() => setShowConfirmacao(false)}
        enviando={enviando}
      />

      <ModalResultadoEnvio
        show={showResultado}
        resultado={resultadoEnvio}
        onFechar={handleFecharResultado}
      />

      <ModalGerenciarMensagens
        show={showGerenciarMensagens}
        onClose={() => setShowGerenciarMensagens(false)}
      />
    </div>
  );
};

export default CobrancaSms;
